import { BoltIcon, Box, Card, EnvelopeIcon, Flex, Text, UserAvatar } from 'components'
import { startCase } from 'lodash-es'
import { generatePath, useNavigate } from 'react-router'
import { User } from 'types'
import { forceLight } from 'utils'

import { RoutePath } from '../../utils/routing'

interface Props {
  leadCount: number
  sessionCount: number
  user: User
  workspaceId: string
}

export default function OnTheGoCard({ leadCount, sessionCount, user, workspaceId }: Props) {
  const navigate = useNavigate()

  function goToMemberPage() {
    if (!user.id) return
    navigate(generatePath(RoutePath.OnTheGoMember, { id: user.id, workspaceId }))
  }

  return (
    <Box
      {...forceLight}
      borderRadius="xl"
      boxShadow="0px 4px 16px 0px rgba(0, 0, 0, 0.10)"
      overflow="hidden"
    >
      <Card
        body={
          <Flex direction="column" gap={1} overflow="hidden">
            {user.displayName ? (
              <Text textStyle="bodyLarge" truncate textOverflow="ellipsis">
                {user.displayName}
              </Text>
            ) : (
              <Text textStyle="bodyLarge" as="i" color="gray">
                Member
              </Text>
            )}
            <Flex align="center" gap={2} overflow="hidden">
              <EnvelopeIcon size="sm" type="outline" />
              <Text textStyle="bodyXSmall" opacity={0.7} truncate textOverflow="ellipsis">
                {user.email}
              </Text>
            </Flex>
          </Flex>
        }
        bodyProps={{ pb: 3 }}
        cursor="pointer"
        footer={
          <Flex alignItems="center" direction="row" gap={2}>
            <BoltIcon fontSize="md" />
            <Text textStyle="bodySmall">
              {sessionCount.toLocaleString()} {sessionCount === 1 ? 'Session' : 'Sessions'}
              {leadCount > 0
                ? ` · ${leadCount.toLocaleString()} ${leadCount === 1 ? 'Lead' : 'Leads'}`
                : ''}
            </Text>
          </Flex>
        }
        footerProps={{
          backdropFilter: 'blur(40px)',
          bg: 'rgba(137, 137, 137, 0.05)',
          boxShadow: '0px 7px 16px 0px rgba(0, 0, 0, 0.08)',
          display: 'flex',
          p: 3,
          pl: 4,
        }}
        header={
          <Flex
            align="center"
            bg="linear-gradient(135deg, rgba(99, 102, 241, 0.12) 0%, rgba(168, 85, 247, 0.12) 100%)"
            height="144px"
            justify="center"
          >
            <UserAvatar hideTooltip size="xl" user={user} />
          </Flex>
        }
        onClick={goToMemberPage}
      />
    </Box>
  )
}